module.exports = __webpack_public_path__ + "img/symbol_7.7a4d62a2.png";